import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  CircularProgress,
  Box,
  Paper,
  Typography,
  IconButton
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import apiClient from "../utils/apiClient";
import { Visibility, VisibilityOff } from "@mui/icons-material";

const ResetPassword = () => {
  const [isPasswordShow, setIsPasswordShow] = useState(false);
  const [isPasswordShow2, setIsPasswordShow2] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [formFields, setFormsFields] = useState({
    newPassword: '',
    confirmPassword: '',
    token: ''
  });

  const history = useNavigate();
  const location = useLocation();

  const onChangeInput = (e) => {
    const { name, value } = e.target;
    setFormsFields({
      ...formFields,
      [name]: value
    });
  };

  const passwordValidation = (value) => {
    const regex =
      /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&#^])[A-Za-z\d@$!%*?&#^]{8,}$/;
    return regex.test(value);
  };

  useEffect(() => {
    const queryParameters = new URLSearchParams(location.search);

    if (queryParameters.get("token")) {
      setFormsFields({
        ...formFields,
        token: queryParameters.get("token")
      });
    }
  }, [location]);

  const valideValue = Object.values(formFields).every(el => el);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formFields.newPassword.trim()) {
      toast.error("Please enter password");
      return;
    } else if (!passwordValidation(formFields.newPassword)) {
      toast.error("Min 8 chars, include uppercase, number & special char");
      return;
    }

    if (!formFields.confirmPassword.trim()) {
      toast.error("Please enter confirm password");
      return;
    }

    if (formFields.confirmPassword !== formFields.newPassword) {
      toast.error("Password and confirm password not match");
      return;
    }

    setIsLoading(true);
    try {
      const res = await apiClient.post("/api/vendor/reset-password", formFields);
      if (res?.data?.success) {
        toast.success(res?.data?.message || "Password reset successful");
        history('/login');
      } else {
        toast.error(res?.data?.message || "Invalid or expired token");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Invalid or expired token");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {formFields.token ? (
        <Box sx={{ py: { xs: 4, lg: 8 } }}>
          <Box sx={{ maxWidth: 400, mx: "auto", px: 2 }}>
            <Paper
              elevation={3}
              sx={{
                p: 4,
                borderRadius: 2,
                bgcolor: "#fff"
              }}
            >
              <Typography
                variant="h6"
                align="center"
                sx={{ mb: 3, fontWeight: 600 }}
              >
                Reset Password
              </Typography>

              <Box component="form" onSubmit={handleSubmit}>
                
                {/* New Password */}
                <Box sx={{ mb: 3, position: "relative" }}>
                  <TextField
                    fullWidth
                    type={isPasswordShow ? "text" : "password"}
                    label="New Password"
                    name="newPassword"
                    value={formFields.newPassword}
                    disabled={isLoading}
                    onChange={onChangeInput}
                  />

                  <IconButton
                    onClick={() => setIsPasswordShow(!isPasswordShow)}
                    sx={{
                      position: "absolute",
                      top: 10,
                      right: 10
                    }}
                  >
                    {isPasswordShow ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </Box>

                {/* Confirm Password */}
                <Box sx={{ mb: 3, position: "relative" }}>
                  <TextField
                    fullWidth
                    type={isPasswordShow2 ? "text" : "password"}
                    label="Confirm Password"
                    name="confirmPassword"
                    value={formFields.confirmPassword}
                    disabled={isLoading}
                    onChange={onChangeInput}
                  />

                  <IconButton
                    onClick={() => setIsPasswordShow2(!isPasswordShow2)}
                    sx={{
                      position: "absolute",
                      top: 10,
                      right: 10
                    }}
                  >
                    {isPasswordShow2 ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </Box>

                {/* Submit Button */}
                <Box sx={{ mt: 2 }}>
                  <Button
                    type="submit"
                    fullWidth
                    disabled={!valideValue}
                    variant="contained"
                    sx={{
                      py: 1.5,
                      fontWeight: 600
                    }}
                  >
                    {isLoading ? (
                      <CircularProgress size={24} color="inherit" />
                    ) : (
                      "Change Password"
                    )}
                  </Button>
                </Box>

              </Box>
            </Paper>
          </Box>
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "60vh"
          }}
        >
          <Typography
            sx={{
              fontSize: "40px",
              fontWeight: 600,
              color: "#ddd"
            }}
          >
            Token Not Found
          </Typography>
        </Box>
      )}
    </>
  );
};

export default ResetPassword;